var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoRecording(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7465_807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3C2.11929 3 1 4.11929 1 5.5V8.33681C1.31085 8.18915 1.64693 8.08595 2 8.03544V5.5C2 4.67157 2.67157 4 3.5 4H10.5C11.3284 4 12 4.67157 12 5.5V12.5C12 13.3284 11.3284 14 10.5 14H10V15H10.5C11.8807 15 13 13.8807 13 12.5V11.5L15.4 13.3C16.0592 13.7944 17 13.324 17 12.5V5.49998C17 4.67594 16.0592 4.20556 15.4 4.69998L13 6.49998V5.5C13 4.11929 11.8807 3 10.5 3H3.5ZM13 7.74998L16 5.49998V12.5L13 10.25V7.74998ZM0 11.5C0 10.1193 1.11929 9 2.5 9H6.5C7.88071 9 9 10.1193 9 11.5V15.5C9 16.8807 7.88071 18 6.5 18H2.5C1.11929 18 0 16.8807 0 15.5V11.5ZM4.02008 11.534C3.94209 11.4811 3.85564 11.4546 3.7607 11.4546C3.69458 11.4546 3.63186 11.4687 3.57252 11.4969C3.51319 11.5234 3.46148 11.5596 3.41741 11.6054C3.37333 11.6513 3.33773 11.7051 3.31061 11.7668C3.28518 11.8286 3.27246 11.8938 3.27246 11.9626V15.0374C3.27246 15.1045 3.28518 15.1689 3.31061 15.2306C3.33773 15.2924 3.37333 15.347 3.41741 15.3947C3.46318 15.4405 3.51573 15.4776 3.57507 15.5058C3.6344 15.5323 3.69628 15.5455 3.7607 15.5455C3.80986 15.5455 3.85564 15.5384 3.89802 15.5243C3.94209 15.5102 3.98532 15.489 4.02771 15.4608L6.32395 13.8943C6.39346 13.8485 6.44771 13.7867 6.4867 13.7091C6.52569 13.6315 6.54519 13.5503 6.54519 13.4656C6.54519 13.3774 6.52485 13.2963 6.48416 13.2222C6.44347 13.1463 6.38753 13.0855 6.31633 13.0396L4.02008 11.534Z",
    fill: "#065B70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7465_807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17.2599,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRecording);
export default __webpack_public_path__ + "static/media/Video Recording.f7305647156a18ab6ebce1e520966925.svg";
export { ForwardRef as ReactComponent };